"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "flex justify-center" };
const _hoisted_2 = {
    key: 0,
    class: "container mx-auto py-4 print:text-[10px] absolute"
};
const _hoisted_3 = { class: "font-bold text-2xl text-center mb-3" };
const _hoisted_4 = { class: "font-bold text-center mb-3" };
const _hoisted_5 = { class: "p-4 mb-5 flex bg-white border border-gray rounded" };
const _hoisted_6 = { class: "w-1/2" };
const _hoisted_7 = { class: "font-bold mb-3 underline underline-offset-8" };
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { class: "w-1/2" };
const _hoisted_10 = { class: "font-bold mb-3 underline underline-offset-8" };
const _hoisted_11 = {
    key: 0,
    class: "hidden print:block"
};
const _hoisted_12 = {
    key: 1,
    class: "hidden print:block"
};
const _hoisted_13 = {
    key: 2,
    class: "hidden print:block"
};
const _hoisted_14 = {
    key: 3,
    class: "hidden print:block"
};
const _hoisted_15 = {
    key: 4,
    class: "hidden print:block"
};
const _hoisted_16 = {
    key: 5,
    class: "hidden print:block"
};
const _hoisted_17 = { class: "bg-white p-4 mt-5 border border-gray rounded" };
const _hoisted_18 = { class: "hidden print:block" };
const _hoisted_19 = { class: "font-sans print:whitespace-pre-wrap" };
const _hoisted_20 = { class: "flex mt-[60px]" };
const _hoisted_21 = { class: "w-1/3 flex" };
const _hoisted_22 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "grow border-b-1 border-black h-[25px]" }, null, -1);
const _hoisted_23 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "w-1/3" }, null, -1);
const _hoisted_24 = { class: "w-1/3" };
const _hoisted_25 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "w-full border-b-1 border-black h-[25px]" }, null, -1);
const _hoisted_26 = {
    key: 0,
    class: "w-full text-center"
};
const _hoisted_27 = { class: "flex gap-5 justify-center mt-4 print:hidden" };
const vue_3 = require("vue");
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const CartSummary_vue_1 = __importDefault(require("./CartSummary.vue"));
const TextareaInput_vue_1 = __importDefault(require("../../components/Form/TextareaInput.vue"));
const i18n_1 = require("../../common/i18n");
const securityStore_1 = require("../../stores/security/securityStore");
const shop_1 = require("../../common/utils/shop");
const vue_router_1 = require("vue-router");
const quotationStore_1 = require("../../stores/quotation/quotationStore");
const toastStore_1 = require("../../stores/toast/toastStore");
const validators_1 = require("../../common/utils/validators");
const cartsStore_1 = require("../../stores/carts/cartsStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Quote',
    setup(__props) {
        const cartsStore = (0, cartsStore_1.useCartsStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const quotationStore = (0, quotationStore_1.useQuotationStore)();
        const customerName = (0, vue_3.ref)("");
        const customerZipCode = (0, vue_3.ref)("");
        const customerCity = (0, vue_3.ref)("");
        const customerStreet = (0, vue_3.ref)("");
        const customerPhonenumber = (0, vue_3.ref)("");
        const customerEmail = (0, vue_3.ref)("");
        const date = (0, vue_3.ref)("");
        const quotationID = (0, vue_3.ref)("");
        const cartSummary = (0, vue_3.ref)(null);
        const noteLine1 = (0, i18n_1.trans)("note_default_line_1", `The quotation is valid until:`, "quote");
        const noteLine2 = (0, i18n_1.trans)("note_default_line_2", `The prices in the quotation are subject to change.`, "quote");
        const noteLine3 = (0, i18n_1.trans)("note_default_line_3", `Our quotation is in HUF and includes 100% of the environmental product fee.`, "quote");
        const noteLine4 = (0, i18n_1.trans)("note_default_line_4", `The price(s) indicated in the gross value column are inclusive of VAT.`, "quote");
        const note = (0, vue_3.ref)(`${noteLine1} ${date.value}.\n${noteLine2}\n${noteLine3}\n${noteLine4}`);
        const activeCart = (0, vue_3.computed)(() => cartsStore.activeCart);
        (0, vue_3.onBeforeMount)(() => {
            document.body.style.backgroundColor = "#fff";
        });
        (0, vue_3.onMounted)(() => {
            date.value = setDate(10);
        });
        (0, vue_3.onUnmounted)(() => {
            document.body.style.backgroundColor = "";
        });
        const checkRequiredFields = () => {
            if ((0, validators_1.isBlank)(customerName.value) ||
                (0, validators_1.isBlank)(customerZipCode.value) ||
                (0, validators_1.isBlank)(customerCity.value) ||
                (0, validators_1.isBlank)(customerStreet.value)) {
                alert((0, i18n_1.trans)('fill_required_fields', 'Please fill in all the required fields before proceeding.', 'quote'));
                return;
            }
        };
        const print = async () => {
            checkRequiredFields();
            await saveDataAndCreateQuotation(true);
        };
        const download = async () => {
            checkRequiredFields();
            await saveDataAndCreateQuotation(false, true);
        };
        const saveDataAndCreateQuotation = async (print = false, download = false) => {
            var _a, _b;
            if (!((_a = activeCart.value) === null || _a === void 0 ? void 0 : _a.id))
                return;
            if (!customerName.value || !customerZipCode.value || !customerCity.value || !customerStreet.value)
                return;
            try {
                if (quotationID.value) {
                    if (print) {
                        window.print();
                    }
                    if (download) {
                        quotationStore.viewPdf(router, quotationID.value);
                    }
                }
                else {
                    const response = await quotationStore.createQuotation(router, {
                        endUser: {
                            name: customerName.value,
                            zip: customerZipCode.value,
                            city: customerCity.value,
                            street: customerStreet.value,
                            phone: customerPhonenumber.value,
                            email: customerEmail.value
                        },
                        validationDate: date.value,
                        note: note.value,
                        pricingIsActive: cartSummary.value ? cartSummary.value.isCustomPriceViewActive : false,
                        prices: cartSummary.value ? cartSummary.value.prices : {}
                    }, (_b = activeCart.value) === null || _b === void 0 ? void 0 : _b.id);
                    if (response.quotationId) {
                        quotationID.value = response.quotationId;
                    }
                    if (print) {
                        window.print();
                    }
                    if (download) {
                        quotationStore.viewPdf(router, quotationID.value);
                    }
                }
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const setDate = (daysToAdd) => {
            const today = new Date();
            today.setDate(today.getDate() + daysToAdd);
            return (0, shop_1.formatDate)(today);
        };
        const handleTotalGrossValueUpdate = () => {
            quotationID.value = "";
        };
        (0, vue_3.watch)(() => date.value, () => {
            note.value = `${noteLine1} ${date.value}.\n${noteLine2}\n${noteLine3}\n${noteLine4}`;
        });
        (0, vue_3.watch)([customerName, customerZipCode, customerCity, customerStreet, customerPhonenumber, customerEmail, date, note], () => {
            quotationID.value = "";
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                ((0, vue_2.unref)(activeCart) !== undefined)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                        (0, vue_2.createElementVNode)("div", null, [
                            (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("quote", "Quote", "quote")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.d)(new Date(), "iso", "hu-HU")), 1)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("supplier", "Supplier", "quote")), 1),
                                ((0, vue_2.unref)(securityStore).authenticatedUser !== null)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                                        (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((_a = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _a === void 0 ? void 0 : _a.customer.name), 1),
                                        (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((_b = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _b === void 0 ? void 0 : _b.customer.zipCode) + ", " + (0, vue_2.toDisplayString)((_c = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _c === void 0 ? void 0 : _c.customer.city), 1),
                                        (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((_d = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _d === void 0 ? void 0 : _d.customer.street), 1),
                                        (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((_e = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _e === void 0 ? void 0 : _e.customer.email), 1),
                                        (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((_f = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _f === void 0 ? void 0 : _f.customer.formattedMobile), 1),
                                        (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((_g = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _g === void 0 ? void 0 : _g.customer.formattedPhone), 1)
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                (0, vue_2.createElementVNode)("div", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer", "Customer", "quote")), 1),
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    id: "quote-name-input",
                                    modelValue: customerName.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((customerName).value = $event)),
                                    class: "print:hidden mb-3",
                                    placeholder: (0, vue_2.unref)(i18n_1.trans)('customer_name', 'Name', 'quote'),
                                    "show-validity": true,
                                    valid: !(0, vue_2.unref)(validators_1.isBlank)(customerName.value),
                                    "invalid-message": (0, vue_2.unref)(i18n_1.trans)('name_required', 'Name required!', 'quote'),
                                    border: ""
                                }, null, 8, ["modelValue", "placeholder", "valid", "invalid-message"]),
                                (customerName.value.length)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, (0, vue_2.toDisplayString)(customerName.value), 1))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    id: "quote-zip-code-input",
                                    modelValue: customerZipCode.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((customerZipCode).value = $event)),
                                    class: "print:hidden mb-3",
                                    placeholder: (0, vue_2.unref)(i18n_1.trans)('customer_zip_code', 'Zip Code', 'quote'),
                                    "show-validity": true,
                                    valid: !(0, vue_2.unref)(validators_1.isBlank)(customerZipCode.value),
                                    "invalid-message": (0, vue_2.unref)(i18n_1.trans)('zip_code_required', 'Zip Code required!', 'quote'),
                                    border: ""
                                }, null, 8, ["modelValue", "placeholder", "valid", "invalid-message"]),
                                (customerZipCode.value.length)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_12, (0, vue_2.toDisplayString)(customerZipCode.value), 1))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    id: "quote-city-input",
                                    modelValue: customerCity.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((customerCity).value = $event)),
                                    class: "print:hidden mb-3",
                                    placeholder: (0, vue_2.unref)(i18n_1.trans)('customer_city', 'City', 'quote'),
                                    "show-validity": true,
                                    valid: !(0, vue_2.unref)(validators_1.isBlank)(customerCity.value),
                                    "invalid-message": (0, vue_2.unref)(i18n_1.trans)('city_required', 'City required!', 'quote'),
                                    border: ""
                                }, null, 8, ["modelValue", "placeholder", "valid", "invalid-message"]),
                                (customerCity.value.length)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_13, (0, vue_2.toDisplayString)(customerCity.value), 1))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    id: "quote-street-input",
                                    modelValue: customerStreet.value,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((customerStreet).value = $event)),
                                    class: "print:hidden mb-3",
                                    placeholder: (0, vue_2.unref)(i18n_1.trans)('customer_street', 'Street', 'quote'),
                                    "show-validity": true,
                                    valid: !(0, vue_2.unref)(validators_1.isBlank)(customerStreet.value),
                                    "invalid-message": (0, vue_2.unref)(i18n_1.trans)('street_required', 'Street required!', 'quote'),
                                    border: ""
                                }, null, 8, ["modelValue", "placeholder", "valid", "invalid-message"]),
                                (customerStreet.value.length)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_14, (0, vue_2.toDisplayString)(customerStreet.value), 1))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    id: "quote-phone-number-input",
                                    modelValue: customerPhonenumber.value,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((customerPhonenumber).value = $event)),
                                    class: "print:hidden mb-3",
                                    placeholder: (0, vue_2.unref)(i18n_1.trans)('customer_phonenumber', 'Phonenumber', 'quote'),
                                    border: ""
                                }, null, 8, ["modelValue", "placeholder"]),
                                (customerPhonenumber.value.length)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_15, (0, vue_2.toDisplayString)(customerPhonenumber.value), 1))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    id: "quote-email-input",
                                    modelValue: customerEmail.value,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((customerEmail).value = $event)),
                                    class: "print:hidden mb-3",
                                    placeholder: (0, vue_2.unref)(i18n_1.trans)('customer_email', 'Email', 'quote'),
                                    border: ""
                                }, null, 8, ["modelValue", "placeholder"]),
                                (customerEmail.value.length)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_16, (0, vue_2.toDisplayString)(customerEmail.value), 1))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ])
                        ]),
                        (0, vue_2.createVNode)(CartSummary_vue_1.default, {
                            ref_key: "cartSummary",
                            ref: cartSummary,
                            onUpdateTotalGrossValue: handleTotalGrossValueUpdate
                        }, null, 512),
                        (0, vue_2.createElementVNode)("div", _hoisted_17, [
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                id: "quote-validity-of-the-quotation-input",
                                modelValue: date.value,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((date).value = $event)),
                                type: "date",
                                label: (0, vue_2.unref)(i18n_1.trans)('validity_of_the_quotation', 'Validity of the quotation', 'quote'),
                                class: "print:hidden my-5 sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5",
                                border: ""
                            }, null, 8, ["modelValue", "label"]),
                            (0, vue_2.createVNode)(TextareaInput_vue_1.default, {
                                id: "quote-note-textarea-input",
                                modelValue: note.value,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((note).value = $event)),
                                rows: 5,
                                label: (0, vue_2.unref)(i18n_1.trans)('note', 'Note', 'quote'),
                                class: "print:hidden my-5",
                                "textarea-extra-class": "print:text-[10px]",
                                border: ""
                            }, null, 8, ["modelValue", "label"]),
                            (0, vue_2.createElementVNode)("div", _hoisted_18, [
                                (0, vue_2.createElementVNode)("pre", _hoisted_19, (0, vue_2.toDisplayString)(note.value), 1)
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_20, [
                            (0, vue_2.createElementVNode)("div", _hoisted_21, [
                                _hoisted_22,
                                (0, vue_2.createElementVNode)("div", null, ", " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.d)(new Date(), "short", "hu-HU")), 1)
                            ]),
                            _hoisted_23,
                            (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                _hoisted_25,
                                ((0, vue_2.unref)(securityStore).authenticatedUser !== null)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_26, (0, vue_2.toDisplayString)((_h = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _h === void 0 ? void 0 : _h.customer.name), 1))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_27, [
                            (0, vue_2.createElementVNode)("button", {
                                id: "quote-print-button",
                                class: "btn btn-rounded btn-primary",
                                onClick: print
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("print", "Print", "quote")), 1),
                            (0, vue_2.createElementVNode)("button", {
                                id: "quote-download-button",
                                class: "btn btn-rounded btn-primary",
                                onClick: download
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("download", "Download", "quote")), 1)
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
